import * as React from 'react';
import { fetchApi, PageTitle, Section } from 'gossamer-front-end';
import { Button } from 'react-bootstrap';
import { CompoundResponse } from 'gossamer-unified';

export const VoucherCodeTest = (): React.JSX.Element => {
  const [info, setInfo] = React.useState(null);
  const handleClick = async () => {
    const resp: CompoundResponse = await fetchApi('POST', '/main/get-fresh-voucher-code');
    setInfo(resp);
  };
  return (
    <>
      <PageTitle title="Voucher Code Test" />
      <Section title="Test Get Fresh Voucher Code">
        <Button onClick={handleClick}>Test</Button>
        <br />
        <br />
        <br />
        <div>
          <pre>{JSON.stringify(info, null, 2)}</pre>
        </div>
      </Section>
    </>
  );
};
